import { render } from "./VF-KeyValue.vue?vue&type=template&id=31d888ae"
import script from "./VF-KeyValue.vue?vue&type=script&lang=js"
export * from "./VF-KeyValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__